import { Box, SvgIcon, Typography } from '@mui/material';
import { CloudOffOutline as CloudOffIcon } from '@opengov/react-capital-assets';
import React from 'react';

import { CAPITAL_DESIGN_TOKENS } from '../../Components/styleConstants';
import { DATA_OG, DATA_TEST } from '../../enums';

interface IOfflineIndicatorProps {
  condensed?: boolean;
}

export const OfflineIndicatorBase: React.ForwardRefRenderFunction<HTMLDivElement, IOfflineIndicatorProps> = (
  { condensed = false },
  ref
) => {
  return (
    <Box
      ref={ref}
      tabIndex={0}
      role="menuitem"
      aria-label="application is offline"
      aria-disabled={true}
      data-test={DATA_TEST.offline_indicator}
      data-og={DATA_OG.offline_indicator}
      sx={{
        display: 'flex',
        gap: 0.5,
        px: 1,
        color: CAPITAL_DESIGN_TOKENS.semanticColors.foreground.warningSmall,
        alignItems: 'center'
      }}
    >
      <SvgIcon component={CloudOffIcon} inheritViewBox sx={{ fontSize: '1.25rem', color: 'inherit' }} />
      {!condensed && (
        <Typography variant="bodyXSmall" sx={{ lineHeight: 'unset' }}>
          Offline
        </Typography>
      )}
    </Box>
  );
};

export const OfflineIndicator = React.forwardRef(OfflineIndicatorBase);
